<template>
    <div>
        <el-table
            ref="multipleTable"
            :data="tableData.slice((currentPage-1)*pagesize,currentPage*pagesize)"
            tooltip-effect="dark"
            style="width: 100%"
            border
             element-loading-text="拼命加载中"
            v-loading = "loading"
            >
            <template slot="empty">
              <p>{{dataText}}</p>
            </template>
            <el-table-column
                v-for='item in tabType' :key="item.index"
                :label="item.label"
                :prop="item.prop"
                :width="item.width"
                >
              <el-table-column 
                v-for='inner of item.child' :key="inner.index"
                :label="inner.label"
                :prop="inner.prop"
                :width="inner.width"
                >
              </el-table-column>
            </el-table-column>
        </el-table>
        <el-pagination
            layout="prev, pager, next"
            @current-change="current_change"
            :page-size="pagesize"
            :total="total"
            v-if="this.total!==0"
            >
        </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'HCLTable',
  data () {
    return {
      currentPage: 1,
      dataText: '暂无数据',
      multipleTable: [],
      total: this.tableData.length
    }
  },
  props: {
    tableData: Array,
    tabType: Array,
    loading: Boolean,
    pagesize: Number
  },
  methods: {
    current_change: function (currentPage) {
      this.currentPage = currentPage
    },
  },
  watch: {
    tableData: {
      handler(val, oldval){
        this.total = val.length
      },
      deep: true
    },
  },
  created() {
  }
}
</script>

<style scoped>
>>> .el-table td, >>> .el-table th {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// HCLTable.vue?5a35b770